import React from 'react';
import { injectIntl } from 'react-intl';
import { Dialog, ScreenMessagePanelContainer, Label } from 'cw-ui-core';
import Locale from 'src/i18n';
import css from './ConfirmApplicationChangesDialog.scss';
import TextButton from 'src/components/TextButton';

export const CONFIRM_APPLICATION_CHANGES_DIALOG = 'CONFIRM_APPLICATION_CHANGES_DIALOG';

const ConfirmApplicationChangesDialog = props => {
    const { formatMessage } = props.intl;

    const dialogButtons = [
        <TextButton key="ok" automationName="ok" text={formatMessage(Locale.ok)} onClick={props.onOk} />,
        <TextButton
            key="cancel"
            automationName="cancel"
            text={formatMessage(Locale.cancel)}
            onClick={props.onCancel}
        />,
    ];

    return (
        <Dialog
            dialogId={CONFIRM_APPLICATION_CHANGES_DIALOG}
            header={formatMessage(Locale.cancelApplicationChanges)}
            buttons={dialogButtons}>
            <br />
            <div className={css.wrap}>
                <ScreenMessagePanelContainer
                    className={css.screenMessage}
                    screenKey={CONFIRM_APPLICATION_CHANGES_DIALOG}
                />
                <Label>{formatMessage(Locale.cancelApplicationChangesConfirmation)}</Label>
            </div>
        </Dialog>
    );
};

export default injectIntl(ConfirmApplicationChangesDialog);
